module.exports = __webpack_public_path__ + "static/media/earth.0faa3192.gif";